import { OverlayCard } from './overlayCard'
import blueBackground from './images/blueTealPatternedBgWithYantra.png'
import blueBackgroundMobile from './images/blueTealPatternedBgWYantraMoblie.png'
import { useReducer } from 'react'
import { getInitialState, reducer } from './quizSection/quizLogic'
import {
  cardHeight,
  cardWidth,
  NUM_QUESTIONS_TO_ASK,
} from './quizSection/quizCardElement'
import { QuizCard } from './quizSection/quizCard'
import QuizResults from './quizSection/deathQuizResult'
import { Box, Button, Text } from '@chakra-ui/react'
import { useMediaQuery } from 'react-responsive';

const QuizPart = ({ state, variant, dispatch, numQuestions }) => {
  const showAnswer = state.results?.show
  let smallMobile = useMediaQuery({ maxWidth: 374 });
  return (
    <Box
      position='relative'
      height={cardHeight}
      width={showAnswer ? 'auto' : (smallMobile ? "300px" : cardWidth)}
      id={'quiz'}
      sx={{
        perspective: `${showAnswer ? 'none' : '40cm'}`,
      }}
      pointerEvents={showAnswer ? undefined : 'none'}
      // display={'flex'}
      // justifyContent={'center'}
      // alignItems={'center'}
      // bg={'red'}
      mx={'0px'} px={'0px'}
      // mr={showAnswer ? undefined : {base: '0%', md: '45%', lg: '30%', xl: '23%', '2xl': '20%'}}
      // mt={showAnswer ? { base: '15%', md: '15%', lg: '8%', 'xl': '8%', '2xl': '5%' } : { base: '-5%', 'lg': '0%', 'xl': '0%', '2xl': '0%' }}
    >
      {state.questions.map((q, index) => {
        return (
          <QuizCard
            key={q.statement}
            q={q}
            index={index}
            isLastCard={state.isLastCard}
            dispatch={dispatch}
            status={state.cards[index].status}
            offset={state.cards[index].offset}
            isCorrect={state.answers[index]}
          />
        )
      })}
      {showAnswer && (
        <QuizResults
          numCorrect={state.results.numCorrect}
          numQuestions={numQuestions}
          showLinkToMainPage={variant === 'page'}
          onRetake={() => { dispatch({ type: 'retake' }) }}
        />
      )}
    </Box>
  )
}

const TextPart = () => {
  return (
    <Box
      width={{base:'313px', md: '392px'}}
      textAlign={'left'}
      position={'absolute'}
      color={'#7B7997'}
      left={{base:'5%', md: '28%', lg: '32%', xl: '5%', '2xl': '12%'}}
      top={{base:'5%', md: '6%', xl:'6%'}}
    >
      <Text
        fontSize={{base:"34px", 'md': '60px' }}
        lineHeight={{base:'36px', 'md': '110%' }}
        fontFamily={'var(--AustinMediumWeb)'}
        mb={'10px'}
      >
        Karma Quiz:
        Myth or Fact?
      </Text>

      <Text fontSize={{ base: '16px', 'md': '24px' }}
        lineHeight={{ base:'25px', 'md': '135%' }}
        fontFamily={'FedraSansStd-book'}
        width={{base:'324px', md: '100%', }}
      >
        Let’s see how well you understand the mechanics of karma!
      </Text>
    </Box>
  )
}
const QuizSectionMarkup = ({ state, variant, dispatch, numQuestions }) => {
  return (
    <Box
      id={'karma-myth-or-fact'}
      position={'relative'}
      bgColor={'#433F68'}
      // bgImage={{
      //   base: 'https://www.datocms-assets.com/46272/1748254290-bluetealpatternedbgwyantramoblie.png',
      //   md: 'https://www.datocms-assets.com/46272/1748254290-bluetealpatternedbgwithyantra.png',
      //   lg: 'https://www.datocms-assets.com/46272/1748254290-bluetealpatternedbgwithyantra.png',
      // }}
      // sx={{width: '100%', height: {base: '814px', md: '950px', lg: '950px', 'xl': '863px', '2xl': '863px'}}}
      backgroundSize="cover"
      overflow={'hidden'}
      pt={{base:'12rem', md: '20rem', xl:'7rem', '2xl': '7.5rem'}}
      pb={{base:'6rem', md: '9rem', xl: '9rem'}}
    >
      <Box
        // px={['2em', '4em', '6em']}
        // py={'6em'}
        gap={'2em'}
        width={'100%'}
        // height={'100%'}
        // maxWidth={['sm', 'sm', 'lg']}
        minHeight={cardHeight}
        sx={{ textWrap: 'balance' }}
      >
        <TextPart />
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <QuizPart
            state={state}
            variant={variant}
            dispatch={dispatch}
            numQuestions={numQuestions}
          />
        </Box>
      </Box>
    </Box>
  )
}

export const QuizSection = ({
  numQuestions = NUM_QUESTIONS_TO_ASK || 7,
  variant = 'default',
}) => {
  const [state, dispatch] = useReducer(reducer, numQuestions, getInitialState)

  return (
    <QuizSectionMarkup
      state={state}
      dispatch={dispatch}
      numQuestions={numQuestions}
      variant={variant}
    />
  )
}
export default QuizSection